import { useState } from 'react';

// eslint-disable-next-line no-underscore-dangle
let _globalComponentIdState = 0;
function generateId() {
  _globalComponentIdState += 1;
  return _globalComponentIdState;
}

export function useId() {
  const [id] = useState(generateId);
  return `${id}`;
}

export default {
  useId,
};
